<template>
<div>
  <a-row>
    <a-col :span="20" :offset="2" class="css_container">
      <a-card class="css_card" hoverable>
        <p slot="title" class="css_card_title">Login</p>
        <a-form :form="form" @submit="onSubmit">
          <a-form-item>
            <a-input v-decorator="['account',{ rules: [{ required: true, message: 'Please input your Account/Email/EID!' }] }]" placeholder="Account">
              <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input v-decorator="['password',{ rules: [{ required: true, message: 'Please input your Password!' }] }]" type="password" placeholder="Password">
              <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a style="float:left" href="/forgotpassword">forgot password?</a>
            <a-button :loading="isLoading" style="float:right" size="small" type="primary" html-type="submit">Login</a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-col>
  </a-row>
</div>
</template>

<script>
export default {
  name: "Login",

  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (err) return;
        this.isLoading = true;
        this.$api
          .login({
            account: values.account,
            password: values.password
          })
          .then(data => {
            let resp = data.data;

            this.$logger.d("login", "login", {
              response: resp
            });
            if (resp.error) {
              this.$notification.error({
                message: "エラー:" + resp.error.code,
                description: resp.error.description
              });
            } else {
              this.$store.dispatch("updateToken", resp.result.token);
              this.$store.dispatch("updateRefreshToken", resp.result.refresh_token);
              this.$store.dispatch("updateInfo");
              this.$router.push({
                path: "/"
              });
            }

            this.isLoading = false;
          })
          .catch(err => {
            this.$logger.e("Login", "api", {
              error: err
            });
            this.$notification.error({
              message: "エラー",
              description: "サーバ通信エラー"
            });
            this.isLoading = false;
          });
      });
    }
  }
};
</script>
<style scoped>
.css_container {
  margin-top: 100px;
}

.css_card {
  max-width: 500px;
  margin: 0 auto;
}

.css_card_title {
  text-size: 10px;
  margin: 0 0;
  text-align: left;
}
</style>
